import axios from "axios";
import { sendEmail } from "./Email";

// Same-origin Vercel proxy. The proxy holds the x-api-key for the
// cabana-pricing-engine Cloud Function server-side so it never ships in
// the client bundle.
const PROXY_PATH = "/api/calculate-quote";

// Retry covers transient network blips. The Cloud Function is always-warm
// (min-instances=1) so cold starts aren't the concern; these delays are
// tuned for a noisy network rather than container boot.
const RETRY_DELAYS_MS = [400, 1200];

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const calculateQuote = async (data) => {
  let lastError = null;

  for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt++) {
    try {
      const response = await axios.post(PROXY_PATH, data, { timeout: 15000 });
      return response.data;
    } catch (error) {
      lastError = error;
      if (attempt < RETRY_DELAYS_MS.length) {
        await sleep(RETRY_DELAYS_MS[attempt]);
      }
    }
  }

  sendEmail(`Error occurred in ${PROXY_PATH}`, {
    request: data,
    error: lastError,
    attempts: RETRY_DELAYS_MS.length + 1,
  });
  return null;
};
